
import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Dispositivo } from "app/models/dispositivo.model";
import { BehaviorSubject, Observable } from "rxjs";

export abstract class AbDispositivoHub extends AppService {

  abstract endpoint: string;
  abstract mostrarButtonAdicionar: BehaviorSubject<boolean>;

  abstract getAllFabricantesControleAcessoAtivos();
  abstract getAllModelosFabricanteControlaAcesso(fabricanteId: number);
  abstract salvar(dispositivo: Dispositivo): Observable<any>;
  abstract desativar(id: number);
  abstract getAllDispositivos(filter: AppFilter): Observable<any>;
  abstract testarConexao(dispositivo: Dispositivo);
  abstract testarConexaoStatus(dispositivo: Dispositivo);
  abstract getDispositivosControlaAcesso();
  abstract getAllDispositivosColeta(tipoColeta: any): Observable<any>;
  abstract getLogSincronizacao(filter: AppFilter): Observable<any>;
  abstract getLogEventos(filter: AppFilter): Observable<any>;
}